/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_RecentInputs */



/**
* | output |
* | --- |
* | "Recent" |
*
* @param {Explorer_Nav_RecentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_recent = /** @type {((inputs?: Explorer_Nav_RecentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_RecentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recents")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jüngste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Recente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Недавний")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reciente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最近的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最近の")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हाल ही का")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recente")
	return /** @type {LocalizedString} */ ("Recent")
});